<template>
            <b-card class="custom_card" :title="title">
                <div class="underline"></div>
                <slot name="content" v-if="!contentLoading">
                </slot>

                <div class="horizontal_div" v-if="!hideButton">
                    <span class="horizontal_left">
                        <slot name="button_content"   v-if="!contentLoading">
                        </slot>
                    </span>
                        <b-button  class="btn-primary horizontal_right" @click="clickedStart" :disabled="contentLoading || requestLoading">
                            {{ $t('system.maintenance.start') }}
                        </b-button>
                </div>
                <RequestInfo v-if="!hideRequestInfo" style="margin-top: 60px;" class="bottom" 
                         :loader="requestLoading || contentLoading" type="custom" 
                         :ok="ok" :error="error" :okMsg="okMsg" :errorMsg="errorMsg"></RequestInfo>

            </b-card>
</template>

<script>


export default {
    name: 'CustomCard',
    components: {
        
    },
    data: function() {
      return {
       
      }
    },
    props: {
        title: String,
        hideButton: {
            default: false,
            type: Boolean
        },
        hideRequestInfo: {
            default: false,
            type: Boolean
        },
        contentLoading: {
            default: false,
            type: Boolean
        },
        requestLoading: {
            default: false,
            type: Boolean
        },
        okMsg:  {
            default: "",
            type: String
        },
        errorMsg: {
            default: "",
            type: String
        },
        ok: {
            default: false,
            type: Boolean
        },
        error: {
            default: false,
            type: Boolean
        }
    },
    methods: {
      prepareToRequest(){
          this.requestLoading = true;
          this.ok = false;
          this.error = false;
      },
      handleResponse(response){    
        this.requestLoading = false;
        if(response.request.status == 200){
            this.ok = true;
            this.okMsg = this.$t('system.maintenance.operationStarted');
        } else {
            this.error = true;
            this.errorMsg = response.request.statusText;
        }
      },
      clickedStart(){
          this.prepareToRequest();
          this.$emit('clickedButton');
      }

    }
}
</script>


<style scoped lang="scss">


.custom_card {
    position: relative;
    padding-bottom: 40px;
    height: 95%;
}

.horizontal_div {
    margin-top: 10px;

}

.horizontal_left {
  width: 250px;
  float: left;
  margin-right: 10px;
}

.horizontal_right {
  width: 200px;
  float: left;
  margin: 0;

}

.underline {
    border-bottom: 1px solid #cecece;
}

.bottom {
    position: absolute;
    bottom: 10px;
    right: 10px;
    width: 95%;
}


</style>